import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import PhoneAppResource from './PhoneAppResource';
import ReferralPartnerTypeAppResource from './ReferralPartnerTypeAppResource';
import UserAppResource from './UserAppResource';

class ReferralPartnerAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'referral-partner';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'referrals/partners';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'firstName',
            'lastName',
            'email',
            'phoneUuid',
            'description',
            'photoFileUuid',
            'photoFile',
            'referralPartnerTypeUuid',
            'companyName',
            'companyWebsite',
            'companyLogoFileUuid',
            'companyLogoFile',
            'ownerUserUuid',
            'isSelected'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            referralPartnerType: ReferralPartnerTypeAppResource,
            ownerUser: UserAppResource,
            phone: PhoneAppResource,
            photoFile: FileAppResource,
            companyLogoFile: FileAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            firstName: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            lastName: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            email: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            phoneUuid: {
                type: 'string',
            },
            photoFileUuid: {
                type: 'string',
            },
            referralPartnerTypeUuid: {
                type: 'string',
                presence: true,
            },
            companyName: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            companyWebsite: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            companyLogoFileUuid: {
                type: 'string',
            },
            ownerUserUuid: {
                type: 'string',
                presence: true,
            },
            description: {
                type: 'string',
            },
        };
    }

}

export default ReferralPartnerAppResource;
